import { SET_HEADER, SET_MENU } from 'actions/types'
import cloneDeep from 'clone-deep'

import { createReducer } from '../utils'

const getInitialState = () => {
  return {
    activeChangeFlag: true,
    menu: {},
    reportsOverride: null,
  }
}

export const header = createReducer(getInitialState(), {
  [SET_HEADER]: (state: any, payload: any) => {
    let newState = cloneDeep(state)
    const data = payload?.data || {}
    if (data.activeChangeFlag) newState.activeChangeFlag = !newState.activeChangeFlag
    if ('reportsOverride' in data) {
      newState.reportsOverride = data.reportsOverride
    }
    return newState
  },
  [SET_MENU]: (state: any, payload: any) => {
    let newState = cloneDeep(state)
    newState.menu = payload.data
    return newState
  },
})
